/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const ProfessionalDevelopment = ({
    objective,
    teachingProposedDevOpportunity,
}: Partial<{ teachingProposedDevOpportunity: string; objective: string }>) => (
    <>
        <Row>
            <ValueCell label="Proposed Development Activity" value={teachingProposedDevOpportunity} />
        </Row>
        <Row>
            <ValueCell single label="Objective" value={objective} />
        </Row>
    </>
);

export default ProfessionalDevelopment;
